<div class="question-dialog">
  <div class="question-dialog__header">
    <span class="question-dialog__title">Добавление вопроса в чек-лист</span>
    <app-icon class="question-dialog__close-icon" [size]="'24'" [glyph]="'close'" (click)="activeModal.close()"></app-icon>
  </div>

  <div class="question-dialog__content">
    <form [formGroup]="form" class="question-dialog__form">
      <div class="question-dialog__control question-dialog__control--question">
        <label for="text"><span class="title title--s title--required">Вопрос</span></label>
        <div class="question-dialog__field">
          <app-field>
            <textarea class="input-textarea" cols="45" rows="4" id="text" maxlength="150" formControlName="text"></textarea>
          </app-field>
          <span class="question-dialog__meta">Количество символов не более 150</span>
        </div>
      </div>
      <div class="question-dialog__control">
        <label for="type"><span class="title title--s title--required">Ответ</span></label>
        <div class="question-dialog__wrap">
          <app-select
            id="type"
            formControlName="type"
            class="question-dialog__field question-dialog__type"
            [items]="questionTypes"
            [textKey]="'label'"
            (callback)="handleChangeType($event)"
            [name]="'QuestionType'"
          ></app-select>

          <div *ngIf="isChoiceSelected" formArrayName="answer_choices" class="question-dialog__answer-choices">
            <div *ngFor="let answerChoice of answerChoices; index as i" [formGroup]="answerChoice" class="question-dialog__answer">
              <app-field>
                <content-prefix>
                  <button class="question-dialog__field-prefix" *ngIf="i > 0" (click)="handleRemoveAnswer(i)">
                    <app-icon [glyph]="'close'" [size]="'16'" [color]="'gray-dark'"></app-icon>
                  </button>
                </content-prefix>
                <input type="text" class="input-text" formControlName="text" placeholder="Введите ответ" />
              </app-field>
            </div>
            <a class="link link--dotted-blue-grey question-dialog__add-answer" (click)="handleAddAnswer()"> Добавить ответ </a>
          </div>
        </div>
      </div>
      <div class="question-dialog__control">
        <label for="category"><span class="title title--s title--required">Категория</span></label>
        <div class="question-dialog__wrap">
          <app-select id="category" formControlName="category" class="question-dialog__field" [items]="categories" [textKey]="'name'" [name]="'CheckListCategory'"></app-select>
          <a class="link link--dotted-blue-dark question-dialog__add-category" (click)="toggleAddCategory()">
            {{ showCreateCategory ? 'Убрать' : 'Добавить' }}
            категорию
          </a>
        </div>
      </div>
      <div class="question-dialog__control question-dialog__control--optional" *ngIf="showCreateCategory">
        <label></label>
        <app-field class="question-dialog__field">
          <input type="text" class="input-text" formControlName="createCategory" placeholder="Введите название категории" />
        </app-field>
      </div>
    </form>
  </div>
  <div class="question-dialog__footer">
    <div class="question-dialog__actions">
      <button type="submit" class="button question-dialog__submit" (click)="handleSubmit()" [disabled]="form.invalid">Сохранить</button>
      <a class="link link--dotted-gray-dark question-dialog__cancel" (click)="activeModal.close()"> Отмена </a>
    </div>
  </div>
</div>
